import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import { Icon20 } from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  height: 50px;
`
export const Text = styled.div`
  display: flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  color: ${Colors.Neutral80};
  ${Typography.Body};
  ${FontWeights.Medium};
  padding: ${Spacing.XS} ${Spacing.S};
  background-color: ${Colors.White};
  border-radius: ${Spacing['3XL']};
`

export const ChevronRight = styled(Icon20.ChevronDown)`
  transform: rotate(270deg);
`
